import Apollo from '@/store/interfaces/Apollo'
import gql from 'graphql-tag'
import { storage } from '@/utils/storage'

const apollo = new Apollo(process.env.VUE_APP_CRAFT_API, false)
apollo.setToken('Bearer ' + process.env.VUE_APP_CRAFT_TOKEN)
const graphqlClient = apollo.client

const site = process.env.VUE_APP_CRAFT_WEBSITE

class APICraft {

  getCategories () {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchGlobal {
            categories (site: "${site}") {
              title
              ... on btRealisationType_Category {
                id
                title
                image {
                  id
                  url
                }
                color
              }
              groupHandle
            }
            entries(site: "${site}", type: "btRegion"){
              title
              id
              ... on btSection_btRegion_Entry {
                geolocalisation {
                  lat
                  lng
                }
                
                object3d {
                  url
                }
                degree
                scale
                btContactEmail
                btContactLink
                btContactPhone
                btContactPostalAddress
                image {
                  id
                }
                personName
              }
            }
          }
        `
      })
      .then(res => {
                
        const result = [...res.data.categories,...res.data.entries]

        resolve(result)
        // storage.setItem( `fetchGlobal_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchGlobal_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getEntries (realisationCategories, regionCategories) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEntries ($realisationCategories: [QueryArgument], 
          ) {
            entries(site: "${site}", btCatReal: $realisationCategories) {
              typeHandle
              ... on btSection_btKReal_Entry {
                id
                title
                slug
                wysiwyg
                geolocalisation {
                  lat
                  lng
                }
                object3d {
                  url
                }
                author {
                  fullName
                }
                degree
                scale
                
                btCatReal {
                  ... on btRealisationType_Category {
                    id
                    title
                    color
                    image {
                      id
                      url
                    }
                  }
                }
                region: parent {
                  title
                  id
                  ... on btSection_btRegion_Entry {
                    object3d {
                      url
                    }
                    degree
                  }
                }
                image {
                  id
                  url
                }
                degree
              }
              ... on btSection_btVille_Entry {
                id
                geolocalisation {
                  lat
                  lng
                }
                title
                fontSize
              }
              dateCreated
              ... on btSection_btRegion_Entry {
                id
                title
                geolocalisation {
                  lat
                  lng
                }
                degree
                object3d {
                  url
                }
                scale
              }
            }
          }
        `,
        variables: { realisationCategories }
      })
      .then(res => {
        
        const result = res.data.entries

        resolve(result)
        // storage.setItem( `fetchEntries_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchEntries_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getCategoryCount(categoryId) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchCount($categoryId: [QueryArgument]) {
            entryCount(
              type: "btKReal"
              ${categoryId ? 'btCatReal: $categoryId,' : ''}
              site: "${site}")
          }
        `,
        variables: { categoryId }
      })
      .then(res => {
        const result = res.data.entryCount

        resolve(result)
        // storage.setItem( `fetchGlobal_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchGlobal_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  imgSize ({id, width, height}) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      let query = {}

      if (width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int, $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true, height: $height)
                }
              }
            }
          `,
          variables: { id, width, height }
        }
      }
      else if (width && !height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true)
                }
              }
            }
          `,
          variables: { id, width }
        }
      }
      else if (!width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(height: $height, immediately: true)
                }
              }
            }
          `,
          variables: { id, height }
        }
      }
      else {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument])  {
              asset(id: $id) {
                ... on default_Asset {
                  url
                }
              }
            }
          `,
          variables: { id }
        }
      }

      graphqlClient.query(query)
        .then(res => {
          resolve(res.data.asset.url)

          const result = res.data.asset.url

          resolve(result)
          // storage.setItem( `fetchImg_${JSON.stringify(args)}`, result)
        })
        .catch(err => {
          console.error('Error catching global params ', err)
        })
    })

    const cache = storage.getItem(`fetchImg_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }
}

export const api = new APICraft()